import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import { PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';

import ListLotteryWinnings from './submodules/list';

const LotteryWinningsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				configPageName={PAGE_NAMES.userProfile}
				configResourceName={USER_PROFILE_RESOURCES.lotteryWinnings}
				configActionName='getLotteryWinningList'
				path={`${path}/list`}
				component={ListLotteryWinnings}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default LotteryWinningsDashboard;
